import {toJS} from 'mobx';
import PropTypes from 'prop-types';
import React from 'react';
import NumericInput from 'react-numeric-input';

import {actionUpdateComponent} from '../../../../../display/components/action/actionUpdateComponent';
import {getComposeForSource} from '../../../../../display/components/common/composeComponent';
import {
  DEFAULT_DROP_SHADOW,
  getTextForSource,
  getTextFromSource
} from '../../../../../display/components/type/textComponent';

import './dropShadowBlurSelect.scss';

/**
 * The minimum dropShadow size.
 * @const {string}
 */
const SHADOW_BLUR_MIN = 0;

/**
 * The maximum dropShadow size.
 * @const {string}
 */
const SHADOW_BLUR_MAX = 50;

/**
 * The DropShadowSizeSelect component.
 *
 * @param {{}} props
 * @param {DisplayEditorStore} props.displayEditorStore
 * @param {ObservableMap} props.entity
 * @param {GameStore} props.game
 * @returns {React.Component}
 */
export const DropShadowBlurSelect = (props) => {
  const {
    /** @type DisplayEditorStore} */ displayEditorStore,
    /** @type {ObservableMap} */ entity,
    /** @type {GameStore} */ game,
  } = props;

  /**
   * Updates the text entity when it is changed.
   *
   * @param {number} valueAsNumber
   */
  const onChange = (valueAsNumber) => {
    const actionParams = {
      entityId: entity.get('id'),
    };

    const composeSource = getComposeForSource(entity);
    const textSource = getTextForSource(entity);
    if (!textSource.text.dropShadow) {
      textSource.text.dropShadow = {...DEFAULT_DROP_SHADOW};
    }
    textSource.text.dropShadow.blur = valueAsNumber;

    game.addAction(actionParams, actionUpdateComponent(
      getTextFromSource(
        {...textSource, ...composeSource},
        toJS(displayEditorStore.variables)
      )
    ));
  };

  const text = entity.get('text');
  const value = (text.dropShadow) ? text.dropShadow.blur : 0;

  return (
    <div className="drop-shadow-size-select">
      <NumericInput
        id="drop-shadow-selector-input-blur"
        className="form-control form-control-sm"
        min={SHADOW_BLUR_MIN}
        max={SHADOW_BLUR_MAX}
        value={value}
        onChange={onChange}
        mobile
      />
    </div>
  );
};

DropShadowBlurSelect.propTypes = {
  displayEditorStore: PropTypes.object.isRequired,
  entity: PropTypes.object.isRequired,
  game: PropTypes.object.isRequired,
};

export default DropShadowBlurSelect;
